import React, { useState } from "react";
import { Row, Col, Typography, Menu, Dropdown, Grid, Divider } from "antd";
import {
  MenuOutlined,
  TeamOutlined,
  ReadOutlined,
  BookOutlined,
} from "@ant-design/icons";
import logo from "../assets/logo.png";
import { Link } from "react-router-dom";
import aboutImage from "../assets/about-us.png";
import CommonFooter from "../components/common/CommonFooter";
import InstantCallModal from "../components/common/InstantCallModal";

const { Title, Paragraph, Text } = Typography;
const { useBreakpoint } = Grid;

const AboutUsPage = () => {
  const screens = useBreakpoint();
  const [menuVisible, setMenuVisible] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const handleInstantCallClick = (e) => {
    e.preventDefault();
    setMenuVisible(false);
    setIsModalVisible(true);
  };

  const handleModalClose = () => {
    setIsModalVisible(false);
  };

  const menu = (
    <Menu
      theme="dark"
      style={{
        background: "rgba(0, 0, 0, 0.95)",
        color: "#fff",
        padding: screens.xs ? "8px 16px" : "10px 25px",
        borderRadius: "6px",
        minWidth: screens.xs ? "200px" : "250px",
      }}
      items={[
        {
          key: "0",
          label: (
            <Link
              to="/"
              style={{
                color: "white",
                fontSize: screens.xs ? "14px" : "inherit",
              }}
              onClick={() => setMenuVisible(false)}
            >
              Home
            </Link>
          ),
        },
        {
          key: "1",
          label: (
            <Link
              to="/about-us"
              style={{
                color: "white",
                fontSize: screens.xs ? "14px" : "inherit",
              }}
              onClick={() => setMenuVisible(false)}
            >
              Who We Are
            </Link>
          ),
        },
        {
          key: "2",
          label: (
            <Link
              to="/listed-property"
              style={{
                color: "white",
                fontSize: screens.xs ? "14px" : "inherit",
              }}
              onClick={() => setMenuVisible(false)}
            >
              Our Offerings
            </Link>
          ),
        },
        {
          key: "3",
          label: (
            <Link
              to="/work"
              style={{
                color: "white",
                fontSize: screens.xs ? "14px" : "inherit",
              }}
              onClick={() => setMenuVisible(false)}
            >
              How NITM Works
            </Link>
          ),
        },
        {
          key: "4",
          label: (
            <Link
              to="/policy"
              style={{
                color: "white",
                fontSize: screens.xs ? "14px" : "inherit",
              }}
              onClick={() => setMenuVisible(false)}
            >
              List Your Property
            </Link>
          ),
        },
        {
          key: "5",
          label: (
            <Link
              to="/news-room"
              style={{
                color: "white",
                fontSize: screens.xs ? "14px" : "inherit",
              }}
              onClick={() => setMenuVisible(false)}
            >
              News Room
            </Link>
          ),
        },
        {
          key: "6",
          label: (
            <Link
              to="/contact-us"
              style={{
                color: "white",
                fontSize: screens.xs ? "14px" : "inherit",
              }}
              onClick={() => setMenuVisible(false)}
            >
              Contact Us
            </Link>
          ),
        },
        {
          key: "7",
          label: (
            <Link
              to="/our-story"
              style={{
                color: "white",
                fontSize: screens.xs ? "14px" : "inherit",
              }}
              onClick={() => setMenuVisible(false)}
            >
              Our Story
            </Link>
          ),
        },
        // Instant Call Button - Added from common header
        {
          key: "instant-call",
          label: (
            <div
              onClick={handleInstantCallClick}
              style={{
                color: "#EDC71C",
                padding: "12px 16px",
                marginTop: "10px",
                textAlign: "center",
                fontWeight: "bold",
                fontSize: screens.xs ? "12px" : "14px",
                cursor: "pointer",
                background: "transparent",
                border: "none",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "8px",
                textTransform: "uppercase",
                letterSpacing: "1px",
              }}
            >
              Instant Call
            </div>
          ),
        },
      ]}
    />
  );

  return (
    <div style={{ minHeight: "100vh", background: "#f9f6f4" }}>
      <Row style={{ minHeight: "100vh" }}>
        {/* Left Image Section - Hidden on mobile */}
        {screens.md ? (
          <Col
            md={12}
            style={{
              position: "relative",
              display: "flex",
              alignItems: "stretch",
              overflow: "hidden",
              minHeight: "120vh",
              backgroundColor: "#f9f6f4",
            }}
          >
            <div
              style={{
                width: "100%",
                height: "100%",
                borderRadius: "0 0 140px 0",
                overflow: "hidden",
                lineHeight: 0,
              }}
            >
              <img
                src={aboutImage}
                alt="About Us"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  display: "block",
                  border: "none",
                }}
              />
            </div>

            <Link to="/" style={{ display: "inline-block" }}>
              <img
                src={logo}
                alt="Logo"
                style={{
                  position: "absolute",
                  top: 30,
                  left: 30,
                  height: 70,
                }}
              />
            </Link>
          </Col>
        ) : (
          // Mobile Logo - Top left on mobile
          <div style={{ position: "absolute", top: 20, left: 20, zIndex: 10 }}>
            <Link to="/" style={{ display: "inline-block" }}>
              <img
                src={logo}
                alt="Logo"
                style={{
                  height: screens.xs ? "50px" : "60px",
                }}
              />
            </Link>
          </div>
        )}

        {/* Right Content Section */}
        <Col
          xs={24}
          md={12}
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            background: "#f9f6f4",
            minHeight: "100vh",
          }}
        >
          {/* Header Bar - Smaller on mobile */}
          <div
            style={{
              width: "100%",
              background: "#DDC7BB",
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              height: screens.xs ? "60px" : "80px",
            }}
          >
            <Dropdown
              overlay={menu}
              placement="bottomRight"
              trigger={screens.xs ? ["click"] : ["hover"]}
              open={menuVisible}
              onOpenChange={setMenuVisible}
            >
              <div
                style={{
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  background: "#8f8c8c",
                  padding: screens.xs ? "0 12px" : "0 16px",
                  cursor: "pointer",
                }}
              >
                <MenuOutlined
                  style={{
                    color: "#fff",
                    fontSize: screens.xs ? 16 : 20,
                  }}
                />
              </div>
            </Dropdown>
          </div>

          {/* Main Content - Adjusted for mobile */}
          <div
            style={{
              marginTop: screens.xs ? 40 : 60,
              width: "100%",
              maxWidth: 600,
              textAlign: "left",
              padding: screens.xs ? "0 20px" : "0 40px",
            }}
          >
            <Title
              level={screens.xs ? 3 : 2}
              style={{
                color: "#000",
                marginBottom: screens.xs ? 15 : 20,
                fontSize: screens.xs ? "24px" : "32px",
              }}
            >
              WHO WE ARE
            </Title>

            <Paragraph
              style={{
                fontSize: screens.xs ? 14 : 16,
                color: "#333",
                lineHeight: 1.7,
                textAlign: screens.xs ? "justify" : "left",
              }}
            >
              We're a Dubai-registered brokerage built on trust and
              transparency. Our portfolio spans a diverse range of properties —
              off-plan, distress and ready — from AED 800,000 to AED 1 billion.
              <br />
              <br />
              We deal only in fully verified and authentic projects, directly
              connecting buyers and sellers. Our goal is to eliminate the hassle
              of navigating multiple broker layers and bring clarity and
              confidence to every transaction.
              <br />
              <br />
              At NotInTheMarket, we're building a trusted network where genuine
              opportunities meet genuine people — making business faster,
              simpler and more reliable.
            </Paragraph>

            {/* Sub Sections with Icons - Stack vertically on mobile */}
            <div
              style={{
                display: "flex",
                justifyContent: screens.xs ? "center" : "space-between",
                marginTop: screens.xs ? 40 : 60,
                flexWrap: "wrap",
                gap: screens.xs ? "30px" : "0",
                flexDirection: screens.xs ? "column" : "row",
                alignItems: screens.xs ? "center" : "flex-start",
              }}
            >
              {[
                {
                  icon: (
                    <TeamOutlined
                      style={{
                        fontSize: screens.xs ? 24 : 28,
                        color: "#000",
                      }}
                    />
                  ),
                  title: "Our Team",
                  path: "/team",
                },
                {
                  icon: (
                    <ReadOutlined
                      style={{
                        fontSize: screens.xs ? 24 : 28,
                        color: "#000",
                      }}
                    />
                  ),
                  title: "Newsroom",
                  path: "/news-room",
                },
                {
                  icon: (
                    <BookOutlined
                      style={{
                        fontSize: screens.xs ? 24 : 28,
                        color: "#000",
                      }}
                    />
                  ),
                  title: "Our Story",
                  path: "/our-story",
                },
              ].map((item) => (
                <Link
                  to={item.path}
                  key={item.title}
                  style={{
                    width: screens.xs ? "100%" : "30%",
                    textAlign: "center",
                    cursor: "pointer",
                    textDecoration: "none",
                    color: "inherit",
                    maxWidth: screens.xs ? "200px" : "none",
                  }}
                >
                  <div>
                    {item.icon}
                    <Text
                      style={{
                        display: "block",
                        marginTop: 10,
                        fontWeight: 500,
                        fontSize: screens.xs ? 14 : 15,
                        color: "#000",
                      }}
                    >
                      {item.title}
                    </Text>
                    <Divider
                      style={{
                        borderTop: "1px solid #000",
                        marginTop: 12,
                        marginBottom: 0,
                        width: screens.xs ? "60%" : "80%",
                        marginInline: "auto",
                      }}
                    />
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </Col>
      </Row>

      {/* Footer */}
      <CommonFooter />

      {/* Use the imported InstantCallModal component */}
      <InstantCallModal
        visible={isModalVisible}
        onClose={handleModalClose}
        propertyId={null} // You can pass a propertyId if needed, otherwise null
      />
    </div>
  );
};

export default AboutUsPage;
